import { useState, useRef } from "react";
import { Container, Paper, Box } from "@mui/material";

import { HeroContacto } from "../../components/contacto/HeroContacto";
import { TabsContacto } from "../../components/contacto/TabsContacto";
import { PanelContacto } from "../../components/contacto/PanelContacto";

export const ContactoPages = () => {
  const [opcion, setOpcion] = useState("trabajo");


    const trabajoRef = useRef(null);
    const matriculaRef = useRef(null);
    const admisionRef = useRef(null);


  return (
    <>
      <HeroContacto />
<Box
  sx={{
    position: "relative",
    zIndex: 20,

    mt: {
      xs: 1,
      sm: -3,
      md: -5,
      lg: -4,
    },

    mb: 0,

    "&::before": {
      content: '""',
      position: "absolute",

      display: {
        xs: "none",
        md: "block",
      },

      width: {
        md: 260,
        lg: 360,
        xl: 420,
      },

      height: {
        md: 260,
        lg: 360,
        xl: 420,
      },

      borderRadius: "0 50% 0 0",

      background: "#8f1515",

      left: {
        md: -70,
        lg: -90,
      },

      top: {
        md: -70,
        lg: -90,
      },

      zIndex: 0,
    },

    "&::after": {
      content: '""',
      position: "absolute",

      display: {
        xs: "none",
        md: "block",
      },

      width: {
        md: 260,
        lg: 360,
        xl: 420,
      },

      height: {
        md: 260,
        lg: 360,
        xl: 420,
      },

      borderRadius: "50% 0 0 0",

      background: "#484A75",

      right: {
        md: -0,
        lg: -0,
      },

      top: {
        md: -70,
        lg: -90,
      },

      zIndex: 0,
    },
  }}
>
      
        <Paper
  elevation={0}
  sx={{
    position: "relative",
    overflow: "hidden",

    zIndex: 2,

    minHeight: {
      xs: "auto",
      md: 560,
    },

    p: {
      xs: 3,
      sm: 4,
      md: 6,
      lg: 8,
    },

    borderRadius: {
      xs: "30px 30px 0 0",
      sm: "40px 40px 0 0",
      md: "50px 50px 0 0",
    },

    background: "#fff",

    boxShadow: {
      xs: "0 15px 35px rgba(0,0,0,.08)",
      md: "0 30px 80px rgba(0,0,0,.12)",
    },
  }}
>
           <Container
  maxWidth="lg"
  sx={{
    px: {
      xs: 1.5,
      sm: 2,
      md: 3,
    },
  }}
> 
           <TabsContacto
                opcion={opcion}
                setOpcion={setOpcion}
                trabajoRef={trabajoRef}
                matriculaRef={matriculaRef}
                admisionRef={admisionRef}
            />

             <PanelContacto
                opcion={opcion}
                trabajoRef={trabajoRef}
                matriculaRef={matriculaRef}
                admisionRef={admisionRef}
            />
            </Container>
        </Paper>
      
      </Box>
    </>
  );
};